import { actionCreator } from '../../../helpers/actionCreator'
import * as ActionTypes from './types'

export const getCurrentUserPermissions = actionCreator(ActionTypes.GET_USER_PERMISSIONS)
export const getCurrentUserPermissionsSucceeded = actionCreator(ActionTypes.GET_USER_PERMISSIONS_SUCCEEDED)
export const getCurrentUserPermissionsFailed = actionCreator(ActionTypes.GET_USER_PERMISSIONS_FAILED)